import 'slick-carousel';
let jQuery = require("jquery");

jQuery(document).ready(function () {
  if (jQuery('.media-gallery').length > 0) {

    var $status = jQuery('.gallery-indicator span');

    jQuery('.media-gallery').on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
    });

    jQuery('.media-gallery').slick({
      lazyLoad: 'ondemand',
      infinite: false,
      arrows: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  }

  // debounce function
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }



  // const bookCardstoImportToSlick = document.querySelectorAll('.promoted-apartment-grid .bookcard')

  // Slick for the book now component whick will be found in the homepage
  const checkbookSwiper = document.querySelector('.bookSwiper')
  if (checkbookSwiper) {
    var bookSwiper = jQuery('.bookSwiper').slick({
      infinite: false,
      arrows: true,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      nextArrow: '<button type="button" class="book-next"><svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.4288 1.28564L27.1431 6.99993L21.4288 12.7142" stroke="#765E56" stroke-width="1.14286" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.1431 7L0.857354 7" stroke="#765E56" stroke-width="1.14286" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      prevArrow: '<button type="button" class="book-prev"><svg width="28" height="14" viewBox="0 0 28 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.4288 1.28564L27.1431 6.99993L21.4288 12.7142" stroke="#765E56" stroke-width="1.14286" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.1431 7L0.857354 7" stroke="#765E56" stroke-width="1.14286" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            dots: true,
            arrows: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            arrows: false,
          }
        },
      ]
    });
  }
  // document.addEventListener('DOMContentLoaded', function() {
  const bookNowBlock = document.getElementById('block-booknowblock');
  const luxuriousApartments = document.getElementById('block-luxuriousapartments');
  const className = 'visible'; // Replace with the class you want to toggle

  // Throttle function
  function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if ((Date.now() - lastRan) >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    }
  }

  // Function to add/remove the class based on scroll position and intersection
  function handleScrollAndIntersection(entries = []) {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    let luxuriousApartmentsInView = false;

    if (luxuriousApartments) {
      const luxuriousApartmentsRect = luxuriousApartments.getBoundingClientRect();
      luxuriousApartmentsInView = (
        luxuriousApartmentsRect.top <= viewportHeight &&
        luxuriousApartmentsRect.bottom >= 0
      );
    }

    const shouldAddClass = scrollY > viewportHeight && !luxuriousApartmentsInView;

    if (shouldAddClass) {
      bookNowBlock.classList.add(className);
    } else {
      bookNowBlock.classList.remove(className);
    }
  }

  // Intersection observer to trigger handleScrollAndIntersection
  if (luxuriousApartments) {
    const observer = new IntersectionObserver((entries) => {
      handleScrollAndIntersection(entries);
    }, { threshold: 0 });

    observer.observe(luxuriousApartments);
  }

  // Initial check
  handleScrollAndIntersection();

  // Check on scroll with throttling
  window.addEventListener('scroll', throttle(handleScrollAndIntersection, 200));
  // });



  // Function to handle clicks on links pointing to #block-luxuriousapartments
  function handleLinkClick(event) {
    const targetId = event.currentTarget.getAttribute('href').substring(1); // Get target id without '#'
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      event.preventDefault();
      targetElement.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#' + targetId; // Assuming the homepage is at '/'
    }
  }

  // Select all links pointing to #block-luxuriousapartments
  const links = document.querySelectorAll('a[href="#block-luxuriousapartments"]');
  links.forEach(link => {
    link.addEventListener('click', handleLinkClick);
  });

  // Smooth scroll to #block-luxuriousapartments if redirected from homepage
  if (window.location.hash === '#block-luxuriousapartments' && !luxuriousApartments) {
    window.location.href = '/#block-luxuriousapartments'; // Redirect to homepage with hash
  }

});


